import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-38d32667")

_pushScopeId("data-v-38d32667")
const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_6 = { key: 3 }
const _hoisted_7 = {
  key: 0,
  class: "margin-vert"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Status: TERMINATED")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Rehire")
const _hoisted_10 = {
  key: 1,
  class: "margin-vert"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Status: Active")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Terminate")
const _hoisted_13 = { key: 4 }
const _hoisted_14 = /*#__PURE__*/_createVNode("h2", null, "User Information", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("h2", null, "Login Credentials", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("input", {
  type: "password",
  style: {"display":"none"}
}, null, -1)
const _hoisted_17 = { class: "buttons-container" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Create")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Cancel")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.isEditing)
        ? (_openBlock(), _createBlock("h1", _hoisted_2, "Edit User"))
        : _createCommentVNode("", true),
      (_ctx.signInProvider==='geotab')
        ? (_openBlock(), _createBlock("h1", _hoisted_3, "Geotab user data is updated automatically. Changes to user data should be made on the Geotab portal."))
        : (_openBlock(), _createBlock("h1", _hoisted_4, "New User")),
      _createVNode(_component_el_button, {
        type: "info",
        icon: "el-icon-arrow-left",
        onClick: _ctx.routeBack
      }, {
        default: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.isEditing && !_ctx.isMe)
        ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_6, [
            (_ctx.isUserDeleted)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode(_component_el_tag, {
                    class: "margin-horz",
                    type: "danger",
                    effect: "dark"
                  }, {
                    default: _withId(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "text",
                    onClick: _ctx.rehireUser
                  }, {
                    default: _withId(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_10, [
                  _createVNode(_component_el_tag, {
                    class: "margin-horz",
                    type: "success",
                    effect: "dark"
                  }, {
                    default: _withId(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, { onClick: _ctx.terminateUser }, {
                    default: _withId(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
          ], 512)), [
            [_directive_loading, _ctx.fetchState !== _ctx.FetchStates.FETCHED]
          ])
        : _createCommentVNode("", true),
      (_ctx.isMe)
        ? (_openBlock(), _createBlock("h3", _hoisted_13, "My Account"))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_el_form, {
        model: _ctx.form,
        rules: _ctx.rules,
        ref: "formRef",
        "status-icon": "",
        "label-width": "150px"
      }, {
        default: _withId(() => [
          _hoisted_14,
          _createVNode(_component_el_form_item, {
            label: "First Name",
            prop: "first_name",
            required: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.first_name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.first_name = $event)),
                disabled: !_ctx.canEdit,
                autocomplete: "off"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Last Name",
            prop: "last_name",
            required: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.last_name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.last_name = $event)),
                disabled: !_ctx.canEdit,
                autocomplete: "off"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Email",
            prop: "email",
            required: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.email,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.email = $event)),
                disabled: !_ctx.canEdit,
                autocomplete: "off"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "User ID",
            prop: "user_id",
            required: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.user_id,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.user_id = $event)),
                disabled: !_ctx.canEdit,
                autocomplete: "off"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          (_ctx.isVAR)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "Organization",
                prop: "organizations_id",
                required: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.organizations_id,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.organizations_id = $event)),
                    class: "full-width",
                    filterable: "",
                    placeholder: "Select Organization",
                    disabled: !_ctx.canEdit
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orgs, (org) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: org.id,
                          label: org.name,
                          value: org.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "Customer Admin",
            prop: "customer_admin",
            required: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.form.customer_admin,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.customer_admin = $event)),
                disabled: !_ctx.canEdit
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _hoisted_15,
          _createVNode(_component_el_form_item, {
            label: "Phone Number",
            prop: "phone_number",
            required: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.phone_number,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.phone_number = $event)),
                disabled: !_ctx.canEdit,
                autocomplete: "off"
              }, null, 8, ["modelValue", "disabled"]),
              _hoisted_16
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Password",
            prop: "password",
            required: !_ctx.isEditing
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.password,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.password = $event)),
                type: "password",
                "auto-complete": "off",
                disabled: !_ctx.canEdit
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["required"]),
          _createVNode(_component_el_form_item, {
            label: "Password Confirm",
            prop: "password_confirm",
            required: !_ctx.isEditing
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.password_confirm,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.password_confirm = $event)),
                type: "password",
                "auto-complete": "off",
                disabled: !_ctx.canEdit
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["required"]),
          _createVNode(_component_el_form_item, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_17, [
                (_ctx.isEditing)
                  ? (_openBlock(), _createBlock("div", _hoisted_18, [
                      _withDirectives(_createVNode(_component_el_button, {
                        onClick: _ctx.saveUser,
                        type: "primary",
                        disabled: !_ctx.canEdit
                      }, {
                        default: _withId(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]), [
                        [_directive_loading, _ctx.saveState === _ctx.FetchStates.FETCHING]
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_20, [
                      _createVNode(_component_el_button, { type: "primary" }, {
                        default: _withId(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      })
                    ])),
                _createVNode(_component_el_button, {
                  class: "cancel-button",
                  onClick: _ctx.routeBack
                }, {
                  default: _withId(() => [
                    _hoisted_22
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]), [
        [_directive_loading, _ctx.isEditing && _ctx.fetchState !== _ctx.FetchStates.FETCHED]
      ])
    ])
  ]))
})